import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';

export const ultrahumanXDiscountCodes = {
  [ShopifyStore.IN]: {
    discountCode: 'P9KZSKHGZ7VM',
    discount: 0.15,
    price: '₹199',
    yearlyPrice: 2388,
  },
  [ShopifyStore.AE]: {
    discountCode: 'WV74KZDYH7J0',
    discount: 0.12,
    price: 'AED 9',
    yearlyPrice: 108,
  },
  [ShopifyStore.ROW]: {
    discountCode: 'WV74KZDYH7J0',
    discount: 0.12,
    price: 'USD 2.5',
    yearlyPrice: 30,
  },
  [ShopifyStore.US]: {
    //change
    discountCode: 'WV74KZDYH7J0',
    discount: 0.12,
    price: 'USD 2.5',
    yearlyPrice: 30,
  },
  [ShopifyStore.GB]: {
    //change
    discountCode: 'AJ2381CKFR88',
    discount: 0.15,
    price: 'GBP 2',
    yearlyPrice: 24,
  },
  [ShopifyStore.EU]: {
    //change
    discountCode: 'AJ2381CKFR88',
    discount: 0.15,
    price: 'EUR 2.5',
    yearlyPrice: 30,
  },
  // These need to be updated
  [ShopifyStore.AU]: {
    discountCode: 'AJ2381CKFR88',
    discount: 0.15,
    price: 'AUD 2.5',
    yearlyPrice: 30,
  },
  [ShopifyStore.SA]: {
    discountCode: 'AJ2381CKFR88',
    discount: 0.15,
    price: 'AUD 2.5',
    yearlyPrice: 30,
  },
  [ShopifyStore.MX]: {
    discountCode: 'AJ2381CKFR88',
    discount: 0.15,
    price: 'AUD 2.5',
    yearlyPrice: 30,
  },
  [ShopifyStore.CA]: {
    discountCode: 'WV74KZDYH7J0',
    discount: 0.12,
    price: 'CAD 2.5',
    yearlyPrice: 30,
  },

  [ShopifyStore.ZA]: {
    discountCode: 'WV74KZDYH7J0',
    discount: 0.12,
    price: 'CAD 2.5',
    yearlyPrice: 30,
  },

  [ShopifyStore.JP]: {
    discountCode: 'WV74KZDYH7J0',
    discount: 0.12,
    price: '¥400',
    yearlyPrice: 4800,
  },
};
